import Cookies from 'js-cookie';

import { httpClient } from '@/config/httpClient';

export async function postRemoveDebitNotes(batchDebitNoteIds: string[]) {
  return httpClient.post(
    '/batch-debit-note/remove-debit-notes',
    {
      batchDebitNoteIds,
    },
    {
      headers: {
        Authorization: `Bearer ${Cookies.get('jwt-access-batch')}`,
      },
    },
  );
}
